import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=1b4aeb68&"
import script from "./Sidebar.vue?vue&type=script&lang=ts&"
export * from "./Sidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QList,QItem,QItemSection,QIcon,QItemLabel} from 'quasar'
component.options.components = Object.assign({QList,QItem,QItemSection,QIcon,QItemLabel}, component.options.components || {})
